import ElasticProcessor from '@lib/processors/elastic-processor'
import store from '~/state/store'

const getCatalogueNameById = store.getters['catalogues/getCatalogueNameById']

const TABLE_FILTERS = [
  {
    attribute: 'action',
    label: 'Action',
    icon: 'el-icon-document',
    type: 'select',
    values: [
      { label: 'Create new client', value: 'action_create_new_client' },
      { label: 'Update client', value: 'action_update_client' },
      { label: 'Link new merchants', value: 'action_link_new_merchants' },
      { label: 'Unlink merchants', value: 'action_unlink_merchants' },
      { label: 'Delete client', value: 'action_delete_client' },
      { label: 'Create merchant', value: 'action_create_merchant' },
      { label: 'Associate feed to merchant', value: 'action_associate_feed_to_merchant' },
      { label: 'Activate merchant', value: 'action_activate_merchant' },
      { label: 'Deactivate merchant', value: 'action_deactivate_merchant' },
      { label: 'Update merchant', value: 'action_update_merchant' },
      { label: 'Delete merchant', value: 'action_delete_merchant' },
      { label: 'Delete offer', value: 'action_delete_offer' },
      { label: 'Updated feed merchant', value: 'action_updated_feed_merchant' },
    ],
  },
  {
    attribute: 'updatedAt',
    label: 'Date',
    type: 'date',
    icon: 'el-icon-date',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'userId',
    label: 'Username',
    icon: 'el-icon-document',
    format: getCatalogueNameById,
    elasticSubField: 'lowercase',
  },
  {
    name: 'actionMessage',
    label: 'Action',
    icon: 'el-icon-document',
    elasticSubField: 'lowercase',
  },
  {
    name: 'updatedAt',
    label: 'Date',
    icon: 'el-icon-date',
    format: 'dateTime',
  },
  { type: 'expand' },
]

export default component => ({
  processor: new ElasticProcessor({
    index: 'action-logs',
    component,
    initialDataQuery: {
      pageSize: 25,
      defaultSort: {
        updatedAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'log',
})
